import { render, staticRenderFns } from "./MoveToFixedToaster.vue?vue&type=template&id=33a9573e&scoped=true"
import script from "./MoveToFixedToaster.vue?vue&type=script&lang=js"
export * from "./MoveToFixedToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9573e",
  null
  
)

export default component.exports